export enum VersicherungsSummeGrenzen {
  MIN_VERSSUMME_FUER_S_AND_M = 200000,
  MAX_VERSSUMME_NICHT_STAENDIG_BEWOHNT = 50000,
  MAX_VERSSUMME = 500000,
}
